import { render, staticRenderFns } from "./LogisticWarning.vue?vue&type=template&id=023dc2cf&"
import script from "./LogisticWarning.vue?vue&type=script&lang=js&"
export * from "./LogisticWarning.vue?vue&type=script&lang=js&"
import style0 from "./LogisticWarning.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LogisticWarning.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports